import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { addTag, createTag, singleTagData, recipes } from '__mocks__/mockData/admin-recipes-data';

const AdminRecipesApi = [
  rest.get(`${API_ROOT}search/recipes`, (req, res, ctx) => {
    let searchResults = { ...recipes, results: [...recipes.results] };
    const [field, direction] = req.url.searchParams.get('$sort')?.split(',') || [];
    const [showHidden] = req.url.searchParams.get('showHidden')?.split(',') || [];
    const queryTerm = req.url.searchParams.get('queryTerm')?.toLowerCase() || '';
    let recipeList = [...recipes.results];

    if (showHidden?.toLocaleLowerCase() === 'false') {
      recipeList = [recipes.results[0], recipes.results[1]];
    }
    if (field === 'title.keyword') {
      if (direction !== 'asc') {
        searchResults = {
          ...recipes,
          results: [...recipeList].reverse(),
        };
      } else {
        searchResults.results = recipeList;
      }
    } else {
      searchResults.results = recipeList;
    }

    if (queryTerm) {
      const results = searchResults.results.filter(recipe => recipe.source.title.toLowerCase().includes(queryTerm));
      searchResults = {
        total: recipeList.length,
        results,
      };
    }

    return res(ctx.json(searchResults));
  }),
  rest.get(`${API_ROOT}recipe-tags`, (req, res, ctx) => res(ctx.json(singleTagData))),
  rest.post(`${API_ROOT}recipe-tags`, (req, res, ctx) => res(ctx.json(createTag))),
  rest.patch(`${API_ROOT}recipe-tags/assign`, (req, res, ctx) => {
    req.body?.data?.forEach(recipeTagData => {
      const recipeTagIds = recipeTagData.recipeTagIds.map(t => t.recipeTagId);
      recipes.results.forEach(recipe => {
        // eslint-disable-next-line no-underscore-dangle
        if (recipe._id === recipeTagData.recipeId) {
          const autoPopulatedTags = recipe.source.tags.filter(tag => tag.autoPopulated);
          recipe.source.tags = [...autoPopulatedTags, ...singleTagData.data.filter(tag => recipeTagIds.includes(tag.id))];
        }
      });
    });
    return res(ctx.json(addTag));
  }),
  rest.put(`${API_ROOT}recipe-tags/1`, (req, res, ctx) => {
    // account for the case where we need to unpublish a published tag once it is edited
    singleTagData.data[0] = { ...singleTagData.data[0], isPublished: req.body.isPublished };
    return res(ctx.json(createTag));
  }),
  rest.delete(`${API_ROOT}recipe-tags/${singleTagData.data[1].id}`, (req, res, ctx) => res(ctx.json(singleTagData))),

  rest.post(`${API_ROOT}recipe-details`, (req, res, ctx) => res(ctx.json({}))),
];

export default AdminRecipesApi;
